import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAIConversationVariables = Types.Exact<{
  input: Types.UpdateAIConversationInput;
}>;

export type UpdateAIConversation = {
  updateAIConversation: Pick<
    Types.AIConversation,
    'id' | 'title' | 'private' | 'saved' | 'createdAt' | 'updatedAt'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const UpdateAIConversationDocument = gql`
  mutation UpdateAIConversation($input: UpdateAIConversationInput!) {
    updateAIConversation(input: $input) {
      id
      title
      private
      saved
      createdAt
      updatedAt
      createdBy {
        ...ActorTeaser
      }
    }
  }
  ${ActorTeaser}
`;
export type UpdateAIConversationMutationFn = Apollo.MutationFunction<
  UpdateAIConversation,
  UpdateAIConversationVariables
>;

/**
 * __useUpdateAIConversation__
 *
 * To run a mutation, you first call `useUpdateAIConversation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAIConversation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiConversation, { data, loading, error }] = useUpdateAIConversation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAIConversation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAIConversation, UpdateAIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAIConversation, UpdateAIConversationVariables>(
    UpdateAIConversationDocument,
    options,
  );
}
export type UpdateAIConversationHookResult = ReturnType<typeof useUpdateAIConversation>;
export type UpdateAIConversationMutationResult = Apollo.MutationResult<UpdateAIConversation>;
export type UpdateAIConversationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAIConversation,
  UpdateAIConversationVariables
>;
export function mockUpdateAIConversation({
  data,
  variables,
  errors,
}: {
  data: UpdateAIConversation;
  variables?: UpdateAIConversationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateAIConversationDocument, variables },
    result: { data, errors },
  };
}
